// extracted by mini-css-extract-plugin
module.exports = {"bordaEstiloC":"Registro_bordaEstiloC__N7899","bordaEstiloB":"Registro_bordaEstiloB__2v4c3"};